"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeElementCheckRequest = void 0;
var ThreeElementCheckRequest = /** @class */ (function () {
    function ThreeElementCheckRequest() {
    }
    return ThreeElementCheckRequest;
}());
exports.ThreeElementCheckRequest = ThreeElementCheckRequest;
;
//# sourceMappingURL=threeElementCheck.request.js.map